/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createEstimatedRevenue } from '../fn/estimated-revenue/create-estimated-revenue';
import { CreateEstimatedRevenue$Params } from '../fn/estimated-revenue/create-estimated-revenue';
import { deleteEstimatedRevenue } from '../fn/estimated-revenue/delete-estimated-revenue';
import { DeleteEstimatedRevenue$Params } from '../fn/estimated-revenue/delete-estimated-revenue';
import { EstimatedRevenueDto } from '../models/estimated-revenue-dto';
import { EstimatedRevenueDtoPage } from '../models/estimated-revenue-dto-page';
import { getEstimatedRevenue } from '../fn/estimated-revenue/get-estimated-revenue';
import { GetEstimatedRevenue$Params } from '../fn/estimated-revenue/get-estimated-revenue';
import { listEstimatedRevenues } from '../fn/estimated-revenue/list-estimated-revenues';
import { ListEstimatedRevenues$Params } from '../fn/estimated-revenue/list-estimated-revenues';
import { updateEstimatedRevenue } from '../fn/estimated-revenue/update-estimated-revenue';
import { UpdateEstimatedRevenue$Params } from '../fn/estimated-revenue/update-estimated-revenue';

@Injectable({ providedIn: 'root' })
export class EstimatedRevenueApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listEstimatedRevenues()` */
  static readonly ListEstimatedRevenuesPath = '/v0/estimatedRevenue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listEstimatedRevenues()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEstimatedRevenues$Response(params?: ListEstimatedRevenues$Params, context?: HttpContext): Observable<StrictHttpResponse<EstimatedRevenueDtoPage>> {
    return listEstimatedRevenues(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listEstimatedRevenues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEstimatedRevenues(params?: ListEstimatedRevenues$Params, context?: HttpContext): Observable<EstimatedRevenueDtoPage> {
    return this.listEstimatedRevenues$Response(params, context).pipe(
      map((r: StrictHttpResponse<EstimatedRevenueDtoPage>): EstimatedRevenueDtoPage => r.body)
    );
  }

  /** Path part for operation `createEstimatedRevenue()` */
  static readonly CreateEstimatedRevenuePath = '/v0/estimatedRevenue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createEstimatedRevenue()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEstimatedRevenue$Response(params: CreateEstimatedRevenue$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return createEstimatedRevenue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createEstimatedRevenue$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEstimatedRevenue(params: CreateEstimatedRevenue$Params, context?: HttpContext): Observable<string> {
    return this.createEstimatedRevenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `getEstimatedRevenue()` */
  static readonly GetEstimatedRevenuePath = '/v0/estimatedRevenue/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEstimatedRevenue()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstimatedRevenue$Response(params: GetEstimatedRevenue$Params, context?: HttpContext): Observable<StrictHttpResponse<EstimatedRevenueDto>> {
    return getEstimatedRevenue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEstimatedRevenue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstimatedRevenue(params: GetEstimatedRevenue$Params, context?: HttpContext): Observable<EstimatedRevenueDto> {
    return this.getEstimatedRevenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<EstimatedRevenueDto>): EstimatedRevenueDto => r.body)
    );
  }

  /** Path part for operation `updateEstimatedRevenue()` */
  static readonly UpdateEstimatedRevenuePath = '/v0/estimatedRevenue/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEstimatedRevenue()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEstimatedRevenue$Response(params: UpdateEstimatedRevenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateEstimatedRevenue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEstimatedRevenue$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEstimatedRevenue(params: UpdateEstimatedRevenue$Params, context?: HttpContext): Observable<void> {
    return this.updateEstimatedRevenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteEstimatedRevenue()` */
  static readonly DeleteEstimatedRevenuePath = '/v0/estimatedRevenue/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEstimatedRevenue()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEstimatedRevenue$Response(params: DeleteEstimatedRevenue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteEstimatedRevenue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteEstimatedRevenue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEstimatedRevenue(params: DeleteEstimatedRevenue$Params, context?: HttpContext): Observable<void> {
    return this.deleteEstimatedRevenue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
